export const cardMonthYear = (input: string): string => {
  const [month, year] = input.split('/');
  return `${month.padStart(2, '0')}/${year}`;
};

export const formatDate = (date: Date): string => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  return `${day} ${month}, ${year}`;
};
